export default __webpack_public_path__ + "static/media/house2.9eb2e602.jpg";